module.exports = __webpack_public_path__ + "static/media/Pantheon.88fe0e37.md";